import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCurrentImpersonation } from '../../app/components/impersonation/impersonation-api';

// Loads the server-truth impersonation state (/impersonation/current). Dispatched
// once on app bootstrap; start/stop trigger a full reload, so this re-runs and
// keeps the global state in sync.
export const fetchImpersonation = createAsyncThunk('impersonation/fetchCurrent', async () => {
  return getCurrentImpersonation();
});
